import DialogComponent from "components/Dialog";

export default class StatusDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            mainMode: true,
            showCanceled: true,
        };

        this.state = {
            ...this.defaultState,
            currentWorkStatus: 0,
        };
    }

    show(info, saveCb) {
        this.dialogTitle = "client.editingStatus";
        this.info = info || {};
        this.state.currentWorkStatus = info.workStatus;
        this.saveCb = saveCb;
        super.show();
    }

    save() {
        const { id } = this.info;
        const { currentWorkStatus } = this.state;
        
        if (this.saveCb?.apply)
            this.saveCb(id, currentWorkStatus);

        this.hide();
        
    }

    renderContent() {

        const { treatmentWorkStatus } = this._config;
        const { currentWorkStatus } = this.state;

        return (<div className="flex1" style={{ paddingBottom: "40px" }}>
            {this.insertSelect({
                ref: el => this.workStatusSelector = el,
                itemStyle: "flex1",
                label: "treatmentPlan.treatmentStatus",
                placeHolder: "main.notIndicated",
                translate: true,
                required: true,
                showLeftIcon: false,
                items: treatmentWorkStatus,
                value: currentWorkStatus,
                onChange: this.changeState.bind(this, "currentWorkStatus")
            })}
        </div>);
    }
}
